import { ApplicationType } from '@dealstack/shared/lib/generated';

export const INVESTOR_PHONE_ROUTE = '/auth/register';

export const needsInvestorPhone = (
	user: { phoneNumber?: string | null },
	applicationType: ApplicationType
): boolean =>
	applicationType === ApplicationType.INVESTOR &&
	(user.phoneNumber === null || user.phoneNumber === undefined);
